import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { DataService } from '../../services/data.service';
import { WaiterOption } from '../../models/config.model';
import { NotificationPayload } from '../../models/notification.model';
import { ApiService } from '../../services/api.service';
import { NotificationType } from '../enums';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-waiter',
  templateUrl: './waiter.component.html',
  styleUrls: ['./waiter.component.scss'],
  standalone: false
})
export class WaiterComponent implements OnInit {

  public options: WaiterOption[];
  public selectedOption: string;
  public comment: string;
  public loaded = false;

  constructor(
    public sheetRef: MatBottomSheetRef<WaiterComponent>,
    private toastService: ToastService,
    private dataService: DataService,
    private translateService: TranslateService,
    private apiService: ApiService
  ) { }

  public ngOnInit(): void {
    this.comment = '';
    this.getWaiterOptions(this.dataService.restaurant().id);
  }

  public confirm(confirm: boolean): void {
    if (!confirm) {
      this.sheetRef.dismiss();
      return;
    }

    const notification: NotificationPayload = this.makeWaiterNotification();
    this.apiService.sendNotification(notification).subscribe(() => {
      this.toastService.success(this.translateService.instant('WAITER.SNACKBAR_TITLE'));
    });
    this.sheetRef.dismiss();
  }

  private makeWaiterNotification(): NotificationPayload {
    return {
      type: NotificationType.CallWaiter,
      table: this.dataService.table().id,
      user: this.dataService.getUserId(),
      waiter_option_id: this.selectedOption,
      comment: this.comment
    };
  }

  private getWaiterOptions(restaurantId: string) {
    this.apiService.getWaiterOptions(restaurantId)
      .subscribe(response => {
        this.loaded = true;
        if (response.length > 0) {
          const defaultOption: WaiterOption = {
            id: '',
            key: '',
            name: this.translateService.instant('WAITER.HELP'),
            lang: '',
          };
          this.options = response;
          this.options.unshift(defaultOption);
          this.selectedOption = this.options[0].id;
        }
      });
  }
}
